import { IpWebComponent } from '../../web-components/ip-web-component';
import { TimelineComponentHelper } from './TimelineComponentHelper';

const citationSlideTemplate = document.createElement('template');
citationSlideTemplate.innerHTML = `
<style>
    :host {
        --background-color: #fff;
        --header-font-size: 2.5rem;
        --slide-padding: 10rem;
    }
    .slide-wrapper {
        min-height: 400px;
        background-color: var(--background-color);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: var(--slide-padding);
    }
    .logo {
        height: 50px;
        fill: #333;
    }
    .title {
        text-align: center;
        font-size: var(--header-font-size);
    }
    .text {
        text-align: center;
    }
    .apply-animation {
        opacity: 0;
    }
    .animate-in {
        opacity: 0;
        animation: fade-up var(--animation-duration, 1s);
        animation-fill-mode: forwards;
        animation-delay: var(--animation-delay);
    }

    @media(max-width: 768px) {
        :host {
            --header-font-size: 2rem;
            --slide-padding: 6rem;
        }
    }

    @media(max-width: 576px) {
        :host {
            --header-font-size: 1.8rem;
            --slide-padding: 3rem;
        }
    }

    @keyframes fade-up {
        0% {
            opacity: 0;
            transform: translateY(50px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
<div class="slide-wrapper">
    <svg class="logo" width="100%" height="100%" viewBox="0 0 148 146" version="1.1">
        <g transform="matrix(4.16667,0,0,4.16667,0,-3.74166)">
            <path d="M32.367,13.436C31.958,13.244 31.46,12.947 31.748,11.987C32.132,10.701 32.053,9.164 31.51,7.928C31.214,7.253 30.91,7.006 30.155,7.502C21.912,12.918 17.662,21.177 17.662,32.475C17.662,33.08 17.713,35.33 17.748,35.844L17.776,35.849L21.633,35.849C22.419,35.849 22.819,35.621 22.561,34.498C21.738,30.911 20.795,28.209 22.452,26.278C24.024,24.707 25.278,24.543 29.557,24.543C32.822,24.543 35.469,21.898 35.469,18.633C35.469,16.386 34.213,14.436 32.367,13.436ZM23.312,4.862C23.239,4.654 23.143,4.335 22.794,3.768C21.747,2.059 19.884,0.898 17.734,0.898C15.48,0.898 13.525,2.162 12.528,4.017C12.325,4.376 11.99,4.891 11.13,4.631C9.096,4.017 6.801,4.486 5.194,6.094C3.599,7.688 3.119,9.964 3.718,11.985C3.952,12.77 3.679,13.122 3.188,13.388C1.311,14.403 0,16.351 0,18.633C0,21.196 1.634,23.371 3.916,24.189C4.578,24.379 4.91,24.551 5.275,23.72C8.647,16.059 14.865,8.566 23.312,4.862ZM14.588,34.766C14.588,22.928 19.474,11.662 30.077,5.925C29.901,5.764 29.358,5.341 29.264,5.278C29.003,5.102 28.813,5.146 28.562,5.318C9.342,15.857 10.035,35.553 10.017,35.849L13.582,35.849C14.443,35.849 14.588,35.734 14.588,34.766Z"/>
        </g>
    </svg>
    <h1 class="title apply-animation"></h1>
    <p class="text apply-animation"></p>
</div>
`;

class TimelineSlideCitation extends IpWebComponent {
    private unregisterAnimation: () => void = () => {};
    private timelineComponentHelper: TimelineComponentHelper | undefined;

    constructor() {
        super(citationSlideTemplate);
    }

    // Init component.
    connectedCallback() {
        this.timelineComponentHelper = new TimelineComponentHelper(this);

        // Set background color.
        const backgroundColor = this.getProp('bg-color');
        if (backgroundColor) {
            this.queryUnsafe('.slide-wrapper').setAttribute('style', `--background-color: ${backgroundColor}`);
        }

        // Setup animated text elements in the component.
        this.timelineComponentHelper.setupAnimatedTextElm('.title', 'title', false, 'titleDelay', 'titleDuration');
        this.timelineComponentHelper.setupAnimatedTextElm('.text', 'text', false, 'textDelay', 'textDuration');

        const animatedElmsInShadow = this.queryAll<HTMLElement>('.apply-animation');
        this.unregisterAnimation = this.timelineComponentHelper.enableEnterExitAnimations(
            animatedElmsInShadow,
            'animate-in'
        );
    }

    disconnectedCallback() {
        this.unregisterAnimation();
    }
}

// Define element, if not already defined.
if (customElements.get('slide-citation') === undefined) {
    customElements.define('slide-citation', TimelineSlideCitation);
}
